<template>
    <LoadingIcon v-if="isLoading" style="display: flex; justify-content: center; align-items: center; height: 100vh" />
    <div v-else-if="isUploadLP" style="width: 100vw; height: 100vh; overflow: hidden; background: #fff; display: flex; flex-direction: column">
        <div class="d-flex align-items-center justify-content-between px-3 py-2 bg-dark text-white" style="z-index: 1000; font-size: 13px">
            <div class="d-flex align-items-center" style="gap: 8px">
                <span class="font-weight-bold mr-2"><i class="ri-time-line mr-1"></i>表示期間:</span>
                <button
                    type="button"
                    class="btn btn-sm"
                    :class="activePeriod === 'start' ? 'btn-primary' : 'btn-outline-light'"
                    @click="switchPeriod('start')"
                >
                    LP開始前
                </button>
                <button
                    type="button"
                    class="btn btn-sm"
                    :class="activePeriod === 'going' ? 'btn-primary' : 'btn-outline-light'"
                    @click="switchPeriod('going')"
                >
                    キャンペーン中
                </button>
                <button
                    type="button"
                    class="btn btn-sm"
                    :class="activePeriod === 'end' ? 'btn-primary' : 'btn-outline-light'"
                    @click="switchPeriod('end')"
                >
                    キャンペーン終了後
                </button>
            </div>
            <div>
                <span class="badge badge-success" v-if="uploadPreviewUrl">プレビュー表示中 ({{ activePeriodText }})</span>
                <span class="badge badge-warning" v-else>未アップロード</span>
            </div>
        </div>
        <div style="flex: 1; overflow: hidden; position: relative">
            <iframe v-if="uploadPreviewUrl" :src="uploadPreviewSrc" style="width: 100%; height: 100%; border: none; display: block"></iframe>
            <div v-else class="d-flex justify-content-center align-items-center h-100 text-muted">
                <p class="mb-0">この期間のプレビュー用HTMLが見つかりません。（ZIPがアップロードされていません）</p>
            </div>
        </div>
    </div>
    <div v-else :style="onHandleStyle('pc')">
        <div class="body__preview" :style="onHandleStyle('sp')" :class="`template--default__${templateDefault}`">
            <section
                v-for="(itemLP, idx) in dataBlockPreview"
                :key="idx"
                :id="`${itemLP.key_parent && itemLP.key ? `${itemLP.key_parent}-${itemLP.key}` : itemLP.key}`"
            >
                <div v-if="!blockCustom.includes(itemLP.key)" v-html="itemLP.body_html"></div>
                <!-- block special -->
                <div v-else-if="itemLP.key == 'header_information'">
                    <div v-if="metaDataPrv.status === statusComplete" v-html="prvForm[itemLP.key].html_content_first_view"></div>
                    <!-- <div v-else v-html="prvForm[itemLP.key].html_content_finished_view"></div> -->
                </div>

                <div v-else-if="itemLP.key == 'first_view'">
                    <div v-if="inforBlock(itemLP.key)?.image || inforBlock(itemLP.key)?.finished_image">
                        <div class="image__first_view">
                            <img
                                v-if="!(metaDataPrv.status === statusComplete)"
                                loading="lazy"
                                :src="inforBlock(itemLP.key).image?.path"
                                :alt="inforBlock(itemLP.key).image?.name"
                            />
                            <div v-else>
                                <img
                                    v-if="inforBlock(itemLP.key).finished_image?.path"
                                    loading="lazy"
                                    :src="inforBlock(itemLP.key).finished_image?.path"
                                    :alt="inforBlock(itemLP.key).finished_image?.name"
                                />
                                <div
                                    v-else
                                    class="d-flex align-items-center justify-content-center"
                                    style="background-color: black; opacity: 0.7; height: 500px"
                                >
                                    <h1 class="text-white font-weight-bold" style="font-size: 24px">このキャンペーンは終了しました。</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else v-html="itemLP.body_html"></div>
                </div>
                <div v-else-if="itemLP.key == 'block_prize'" class="block_prizes" :style="onHandleStyle('block_prize')">
                    <div :class="`box--prize__${inforBlock(itemLP.key).style}`">
                        <div v-if="inforBlock(itemLP.key).title_image?.path" class="mb-5">
                            <img :src="inforBlock(itemLP.key).title_image.path" :alt="inforBlock(itemLP.key).title_image.path" class="img__title" />
                        </div>
                        <div v-else>
                            <h2
                                v-if="STYLE_SHOW_TITLE.includes(inforBlock(itemLP.key).style)"
                                class="title-common"
                                :style="onHandleStyle('title_block_prize')"
                            >
                                <span>{{ inforBlock(itemLP.key).title_block }}</span>
                            </h2>
                            <h2 v-else class="title-common" :style="onHandleStyle('title_block_prize')">
                                <div class="title-eng">
                                    <span>{{ inforBlock(itemLP.key).title_block }}</span>
                                </div>
                                <!-- <div class="title-jp"></div> -->
                            </h2>
                        </div>
                        <div class="list__prize" v-html="itemLP.body_html"></div>
                    </div>
                </div>

                <div v-else-if="itemLP.key == 'block_target_product'" class="block_target_product" :style="onHandleStyle('block_target_product')">
                    <div :class="`__${inforBlock(itemLP.key).style}`">
                        <div class="target_product">
                            <div v-if="inforBlock(itemLP.key).title_image?.path" class="mb-5">
                                <img
                                    :src="inforBlock(itemLP.key).title_image.path"
                                    :alt="inforBlock(itemLP.key).title_image.path"
                                    class="img__title"
                                />
                            </div>
                            <div v-else>
                                <h2
                                    v-if="STYLE_SHOW_TITLE.includes(inforBlock(itemLP.key).style)"
                                    class="title-common"
                                    :style="onHandleStyle('title_block_target_product')"
                                >
                                    <span>{{ inforBlock(itemLP.key).title_block }}</span>
                                </h2>
                                <h2 v-else class="title-common" :style="onHandleStyle('title_block_target_product')">
                                    <div class="title-eng">
                                        <span>{{ inforBlock(itemLP.key).title_block }}</span>
                                    </div>
                                    <!-- <div class="title-jp"></div> -->
                                </h2>
                            </div>
                            <div class="list__product" v-html="itemLP.body_html"></div>
                        </div>
                    </div>
                </div>

                <div
                    v-else-if="itemLP.key == 'block_application_method'"
                    class="block__application--methods"
                    :style="onHandleStyle('block_application_method')"
                >
                    <div :class="`box--methods__${inforBlock(itemLP.key).style}`">
                        <div v-if="inforBlock(itemLP.key).title_image?.path" class="mb-5">
                            <img :src="inforBlock(itemLP.key).title_image.path" :alt="inforBlock(itemLP.key).title_image.path" class="img__title" />
                        </div>
                        <div v-else>
                            <h2
                                v-if="STYLE_SHOW_TITLE.includes(inforBlock(itemLP.key).style)"
                                class="title-common"
                                :style="onHandleStyle('title_block_application_method')"
                            >
                                <span>{{ inforBlock(itemLP.key).title_block }}</span>
                            </h2>
                            <h2 v-else class="title-common" :style="onHandleStyle('title_block_application_method')">
                                <div class="title-eng">
                                    <span>{{ inforBlock(itemLP.key).title_block }}</span>
                                </div>
                            </h2>
                        </div>
                        <div class="list__method" v-html="itemLP.body_html"></div>
                    </div>
                </div>

                <div v-else-if="itemLP.key == 'free_blocks' && inforFreeBlock(itemLP)?.style" class="block_free">
                    <div :class="`box--type__${objBlockFree[itemLP.key_parent].style}`">
                        <h2 class="title" :style="onHandleStyle('title_free_block', objBlockFree[itemLP.key_parent])">
                            <span>{{ objBlockFree[itemLP.key_parent].title }}</span>
                        </h2>
                        <div v-html="itemLP.body_html"></div>
                    </div>
                </div>

                <div
                    v-else-if="itemLP.key == 'block_application_rule'"
                    class="block__application--rule"
                    :style="onHandleStyle('block_application_rule')"
                >
                    <div :class="`box--rule__${inforBlock(itemLP.key).style}`">
                        <h2
                            v-if="STYLE_SHOW_TITLE.includes(inforBlock(itemLP.key).style)"
                            class="title-common"
                            :style="onHandleStyle('title_block_application_rule')"
                        >
                            <span>{{ inforBlock(itemLP.key).title_block }}</span>
                        </h2>
                        <h2 v-else class="title-common" :style="onHandleStyle('title_block_application_rule')">
                            <div class="title-eng">
                                <span>{{ inforBlock(itemLP.key).title_block }}</span>
                            </div>
                            <!-- <h2 class="title-jp"></h2> -->
                        </h2>
                        <div class="content-rule-wrapper">
                            <div class="content-rule" v-html="itemLP.body_html"></div>
                        </div>
                    </div>
                </div>

                <div v-else-if="itemLP.key == 'block_contact'">
                    <div id="contactBlock" class="block__contact" :style="onHandleStyle('contact')">
                        <div :class="`box--contact__${inforBlock(itemLP.key).style}`">
                            <h2
                                v-if="STYLE_SHOW_TITLE.includes(inforBlock(itemLP.key).style)"
                                class="title-common"
                                :style="onHandleStyle('title-contact')"
                            >
                                <span>{{ inforBlock(itemLP.key).title_block }}</span>
                            </h2>
                            <h2 v-else class="title-common" :style="onHandleStyle('title-contact')">
                                <div class="title-eng">
                                    <span>{{ inforBlock(itemLP.key).title_block }}</span>
                                </div>
                                <!-- <h2 class="title-jp"></h2> -->
                            </h2>
                            <div class="inquiry-wrapper" v-html="itemLP.body_html"></div>
                        </div>
                    </div>
                </div>

                <div
                    v-else-if="itemLP.key == 'block_share'"
                    id="shareBlock"
                    :style="onStyleShare()"
                    class="block_share d-flex justify-content-center"
                >
                    <div v-for="(itemSocial, idx) in activeSocial" :key="`social-${idx}`" class="social__media">
                        <a
                            class="ela--share"
                            :href="onLinkShare(itemSocial)"
                            :target="`${onLinkShare(itemSocial) !== 'javascript:void(0)' ? '_blank' : '_self'}`"
                            :style="`background-color: ${itemSocial.backgroundColor}`"
                        >
                            <img loading="lazy" :src="itemSocial.logo" :alt="itemSocial.logo" />
                        </a>
                    </div>
                </div>
                <div v-else-if="itemLP.key == 'button_blocks' && inforButtonBlock(itemLP)?.style" class="block_button">
                    <button
                        id="button-link"
                        type="button"
                        :class="`button--type__${objBlockButton[itemLP.key_parent].style}`"
                        :style="onHandleStyle('block-button', objBlockButton[itemLP.key_parent])"
                        @click="onHandleLinkButton(objBlockButton[itemLP.key_parent].url)"
                        :disabled="metaDataPrv.status === statusComplete"
                    >
                        <p :style="onHandleStyle('title-block-button', objBlockButton[itemLP.key_parent])">
                            {{ objBlockButton[itemLP.key_parent].title_button }}
                        </p>
                        <span class="arrow-right"></span>
                    </button>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { handleMapHTML, onHandleSetAttr } from '../../handlers';
import { SOCIAL_MEDIA_SHARE, LIST_FONT_PAGE, STYLE_SHOW_TITLE } from '../../constants';
import { landingPageMethods } from '@/state/helpers';
import { authHeader } from '@/api/handler/main';

import LoadingIcon from '@/components/Loading/main.vue';

export default {
    name: 'ExportLandingPage',
    components: { LoadingIcon },
    props: {},
    computed: {
        activeSocial() {
            return SOCIAL_MEDIA_SHARE?.filter((oBlock) => oBlock.active);
        },
        activePeriodText() {
            if (this.activePeriod === 'start') return 'LP開始前';
            if (this.activePeriod === 'going') return 'キャンペーン中';
            if (this.activePeriod === 'end') return 'キャンペーン終了後';
            return '';
        },
        uploadPreviewSrc() {
            if (!this.uploadPreviewUrl) return '';
            const separator = this.uploadPreviewUrl.includes('?') ? '&' : '?';
            return `${this.uploadPreviewUrl}${separator}_t=${this.previewTimestamp}`;
        }
    },
    data() {
        return {
            prvForm: null,
            metaDataPrv: null,
            isLoading: true,
            dataBlockPreview: [],
            STYLE_SHOW_TITLE: STYLE_SHOW_TITLE,
            statusComplete: 5,
            objBlockFree: {},
            objBlockButton: {},
            url: 'https://paldia-dev.supenient.vn',
            blockCustom: [
                'first_view',
                'block_share',
                'block_contact',
                'block_application_rule',
                'free_blocks',
                'block_prize',
                'block_target_product',
                'block_application_method',
                'button_blocks',
                'header_information'
            ],
            templateDefault: null,
            isUploadLP: false,
            uploadPreviewUrl: '',
            uploadDetailData: null,
            activePeriod: 'going',
            previewTimestamp: Date.now()
        };
    },
    methods: {
        ...landingPageMethods,

        findHtmlUrl(resources) {
            if (!resources || !resources.length) return '';
            const matchedIndex = resources.find((url) => {
                const clean = url.split('?')[0].toLowerCase();
                return clean.endsWith('/index.html') || clean === 'index.html';
            });
            if (matchedIndex) return matchedIndex;
            const stageFallback = resources.find((url) => {
                const clean = url.split('?')[0].toLowerCase();
                return clean.endsWith('/index0.html') || clean.endsWith('/index1.html');
            });
            if (stageFallback) return stageFallback;
            const anyHtml = resources.find((url) => url.split('?')[0].toLowerCase().endsWith('.html'));
            return anyHtml || '';
        },

        switchPeriod(period, isInitial = false) {
            this.activePeriod = period;
            const data = this.uploadDetailData || {};
            let resources = [];
            if (period === 'start') {
                resources = data.resources_zip_start || [];
            } else if (period === 'going') {
                resources = data.resources_zip_going || [];
            } else if (period === 'end') {
                resources = data.resources_zip_end || [];
            }

            // Fallback only on initial load if requested slot is empty and no explicit query was specified
            if (isInitial && !resources.length && !this.$route.query.period) {
                if (data.resources_zip_going?.length) {
                    resources = data.resources_zip_going;
                    this.activePeriod = 'going';
                } else if (data.resources_zip_start?.length) {
                    resources = data.resources_zip_start;
                    this.activePeriod = 'start';
                } else if (data.resources_zip_end?.length) {
                    resources = data.resources_zip_end;
                    this.activePeriod = 'end';
                }
            }

            this.uploadPreviewUrl = this.findHtmlUrl(resources);
            this.previewTimestamp = Date.now();
        },

        getDetailLandingPageCustom(id) {
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            return fetch(process.env.VUE_APP_APIURL + `/landing-pages/${id}`, requestOptions).then((response) => {
                return response.text().then((text) => {
                    const data = text && JSON.parse(text);
                    return data;
                });
            });
        },

        async getDetailPrv() {
            this.isLoading = true;
            try {
                const response = await this.getDetailLandingPageCustom(this.$route.query.id);
                const lpType = response?.data?.lp_type ?? response?.data?.type ?? 1;
                if (lpType === 2) {
                    this.isUploadLP = true;
                    this.uploadDetailData = response?.data;
                    const targetPeriod = this.$route.query.period || this.activePeriod || 'going';
                    this.switchPeriod(targetPeriod, true);
                    this.isLoading = false;
                    return;
                }
                this.templateDefault = response?.data?.style_setting?.template_default?.id ?? null;
                this.metaDataPrv = response._metadata;
                this.prvForm = {
                    ...response.data,
                    style_setting: {
                        ...response.data?.style_setting,
                        font: response.data?.style_setting?.font
                            ? LIST_FONT_PAGE.find((fontDesign) => fontDesign.id == response.data.style_setting.font)
                            : null,
                        pc: {
                            ...response.data?.style_setting?.pc,
                            is_repeat: response.data?.style_setting?.pc?.is_repeat
                                ? response.data?.style_setting?.pc?.is_repeat === 0
                                    ? false
                                    : true
                                : false
                        },
                        sp: {
                            ...response.data?.style_setting?.sp,
                            is_repeat: response.data?.style_setting?.sp?.is_repeat
                                ? response.data?.style_setting?.sp?.is_repeat === 0
                                    ? false
                                    : true
                                : false
                        }
                    }
                };
                this.handleMapPreview(response.data);
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        handleMapPreview(response) {
            this.dataBlockPreview =
                response?.block_arrangement
                    ?.map((itemArrangement, idx) => {
                        itemArrangement.key = itemArrangement?.key === 'prize_settings' ? 'block_prize' : itemArrangement.key;
                        return {
                            block_default: itemArrangement.type === 'predefined',
                            order_index: itemArrangement.position,
                            is_visibled: itemArrangement.status === 1,
                            key: itemArrangement.key ?? '',
                            key_parent: itemArrangement?.key_parent ?? this.prvForm?.block_prize?.[idx]?.key_parent,
                            body_html: handleMapHTML(itemArrangement, response)
                        };
                    })
                    .filter((oBlock) => oBlock.is_visibled) ?? [];

            SOCIAL_MEDIA_SHARE.forEach((itemSocial) => {
                itemSocial.active = response?.block_share?.platform[itemSocial.key].active ?? false;
            });

            onHandleSetAttr(this.prvForm.style_setting);
        },

        onStyleShare() {
            let { background_image, background_color, is_repeat } = this.prvForm?.block_share;
            return `background-color: ${background_color ?? ''};
                    background-image: url(${background_image?.path ?? ''});
                    background-repeat: ${is_repeat ? 'repeat' : 'no-repeat'};
                    overflow: hidden;
                    background-blend-mode: multiply;`;
        },

        onLinkShare(shareUrl) {
            let { block_share } = this.prvForm;
            return block_share.platform[shareUrl.key].url || 'javascript:void(0)';
        },

        onHandleLink() {
            const linkButton = document.getElementById('button-link');
            if (!linkButton) return;
            linkButton.addEventListener('click', function (e) {
                const href = this.getAttribute('href');
                if (!href || href === '#') {
                    e.preventDefault();
                }
            });
        },

        onHandleStyle(type, paramFreeBlock = null) {
            let {
                block_contact,
                block_application_rule,
                block_prize,
                block_target_product,
                block_application_method,
                pc_background_image,
                sp_background_image
            } = this.prvForm;
            let { pc, sp } = this.prvForm?.style_setting;
            switch (type) {
                case 'pc':
                    return `background-color: ${pc.background_color || '#ffffff'};
                            background-image: url(${pc_background_image?.path || ''});
                            background-repeat: ${pc.is_repeat ? 'repeat' : 'no-repeat'};
                            overflow: hidden;
                            background-blend-mode: multiply;`;
                case 'sp':
                    return `background-color: ${sp.background_color || '#ffffff'};
                            background-image: url(${sp_background_image?.path || ''});
                            background-repeat: ${sp.is_repeat ? 'repeat' : 'no-repeat'};`;
                case 'contact':
                    return `background-color: ${block_contact.background_color ?? ''};
                            background-image: url(${block_contact.background_image?.path ?? ''});
                            background-repeat: ${block_contact.is_repeat ? 'repeat' : 'no-repeat'};
                            min-height: 300px;`;
                case 'title-contact':
                    return `background: ${block_contact.background_title ?? ''};
                            color:  ${block_contact.color_title ?? ''};
                            font-size: ${block_contact.size_title}px;`;
                case 'block_application_rule':
                    return `background-color: ${block_application_rule.background_color ?? ''};
                            background-image: url(${block_application_rule.background_image?.path ?? ''});
                            background-repeat: ${block_application_rule.is_repeat ? 'repeat' : 'no-repeat'};
                            min-height: 300px;
                            overflow: hidden;
                            background-blend-mode: multiply;`;
                case 'title_block_application_rule':
                    return `background: ${block_application_rule.background_title ?? ''};
                            color:  ${block_application_rule.color_title ?? ''};
                            font-size: ${block_application_rule.size_title}px;`;
                case 'title_free_block':
                    return `background: ${paramFreeBlock.background_title ?? ''};
                            color:  ${paramFreeBlock.color_title ?? ''};
                            font-size: ${paramFreeBlock.size_title}px;`;
                case 'block_prize':
                    return `background-color: ${block_prize.background_color ?? ''};
                            background-image: url(${block_prize.background_image?.path});
                            background-repeat: ${block_prize.is_repeat ? 'repeat' : 'no-repeat'};`;
                case 'title_block_prize':
                    return `background: ${block_prize.background_title ?? ''};
                            color:  ${block_prize.color_title ?? ''};
                            font-size: ${block_prize.size_title}px;`;
                case 'block_target_product':
                    return `background-color: ${block_target_product?.background_color ?? ''};
                            background-image: url(${block_target_product?.background_image?.path ?? ''});
                            background-repeat: ${block_target_product?.is_repeat ? 'repeat' : 'no-repeat'};`;
                case 'title_block_target_product':
                    return `background: ${block_target_product?.background_title ?? ''};
                            color:  ${block_target_product?.color_title ?? ''};
                            font-size: ${block_target_product?.size_title}px;`;
                case 'block_application_method':
                    return `background-color: ${block_application_method?.background_color ?? ''};
                            background-image: url(${block_application_method?.background_image?.path ?? ''});
                            background-repeat: ${block_application_method?.is_repeat ? 'repeat' : 'no-repeat'};`;
                case 'title_block_application_method':
                    return `background: ${block_application_method?.background_title ?? ''};
                            color:  ${block_application_method?.color_title ?? ''};
                            font-size: ${block_application_method?.size_title}px;`;
                case 'block-button':
                    return `color: ${paramFreeBlock?.color ?? ''};
                            font-family:${LIST_FONT_PAGE.find((itemFont) => itemFont.id == paramFreeBlock?.font_button)?.property_style?.fontFamily ?? ''};
                            background-color: ${paramFreeBlock?.background_color ?? ''};
                            box-shadow: 0 8px 0 ${paramFreeBlock?.background_color ?? ''}; `;
                case 'title-block-button':
                    return `font-family:${LIST_FONT_PAGE.find((itemFont) => itemFont.id == paramFreeBlock?.font_button)?.property_style?.fontFamily ?? ''};`;
            }
        },

        inforFreeBlock(itemKey) {
            const foundBlock = this.prvForm[itemKey.key]?.find((fdt) => fdt.key_parent == itemKey.key_parent);
            this.objBlockFree[itemKey.key_parent] = foundBlock;
            return foundBlock;
        },

        inforButtonBlock(itemKey) {
            const foundBlock = this.prvForm[itemKey.key]?.find((fdt) => fdt.key_parent == itemKey.key_parent);
            this.objBlockButton[itemKey.key_parent] = foundBlock;
            return foundBlock;
        },

        inforBlock(itemKey) {
            return this.prvForm[itemKey];
        },

        onHandleLinkButton(link) {
            if (!link) return '';
            window.open(link, '_blank');
        },

        onStorageChange(e) {
            const lpId = this.$route.query.id;
            if (!lpId) return;
            if (e.key === `lp_${lpId}_last_saved_time`) {
                this.getDetailPrv();
            }
        }
    },
    mounted() {
        this.getDetailPrv();
        window.addEventListener('storage', this.onStorageChange);
    },
    beforeDestroy() {
        window.removeEventListener('storage', this.onStorageChange);
    },
    updated() {
        this.onHandleLink();
    }
};
</script>

<style lang="scss" scoped>
.body__preview {
    font-size: 1rem;
}
</style>
